/**
 * @summary Icon preact component
 */

import { h } from 'preact';

export default function Icon( props ) {
	const icon = props.icon;

	const attributes = Object.assign({}, props );
	delete attributes.icon;

	return (
		<svg {...attributes}>
			<use xlinkHref={`${wp_data.iconSheet}#${icon}`}/>
		</svg>
	);
};



// WEBPACK FOOTER //
// ./src/js/components/icon.js